import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';

const BulkMarkCompleteTasksModal = ({ isOpen, onClose, onConfirm, tasks, loading }) => {
  if (!isOpen || !tasks || tasks.length === 0) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2>Mark Tasks Complete</h2>
          <button className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-content">
          <p>Are you sure you want to mark {tasks.length} task{tasks.length > 1 ? 's' : ''} as complete?</p>
          <div className="bulk-document-list">
            {tasks.slice(0, 5).map(task => (
              <div key={task.taskId} className="bulk-document-item">
                <div className="bulk-document-name">{task.patient?.name || 'Unknown Patient'}</div>
                <div className="bulk-document-assignee">{task.text}</div>
              </div>
            ))}
            {tasks.length > 5 && (
              <div className="bulk-document-more">
                ... and {tasks.length - 5} more task{tasks.length - 5 > 1 ? 's' : ''}
              </div>
            )}
          </div>
          <p style={{ marginTop: '15px', color: '#666', fontSize: '14px' }}>
            All selected tasks will be marked as complete and will no longer appear in incomplete task views.
          </p>
        </div>
        <div className="modal-actions">
          <button className="cancel-button" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="task-submit-button" onClick={onConfirm} disabled={loading}>
            {loading ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              'Mark All Complete'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkMarkCompleteTasksModal;
